import * as Yup from 'yup';
import React from 'react';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { FormFooter } from '../form-footer';
// forms
import { Fieldset2 } from '../../forms';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

const inputWrapperStyles = {
  mb: 25,
  width: 270,
};

const fieldSettings = [
  {
    type: 'text',
    isRequired: true,
    inputWrapperStyles,
    label: ['titles:user-name'],
    fieldName: GC.FIELD_USERNAME,
  },
  {
    type: 'text',
    isRequired: true,
    inputWrapperStyles,
    label: ['titles:password'],
    fieldName: GC.FIELD_PASSWORD,
  },
];

const defaultFields = {
  [GC.FIELD_USERNAME]: null,
  [GC.FIELD_PASSWORD]: null,
};

const validationSchema = () => Yup.object().shape({
  [GC.FIELD_USERNAME]: G.yupStringRequired,
  [GC.FIELD_PASSWORD]: G.yupStringRequired,
});

const enhance = compose(
  withFormik({
    validationSchema,
    mapPropsToValues: () => defaultFields,
    handleSubmit: (values, { props }) => props.submitAction(values),
  }),
  pure,
);

const ConnectToCustomMailForm = (props) => (
  <form onSubmit={props.handleSubmit}>
    <Fieldset2
      {...G.getFormikProps(props)}
      fields={fieldSettings}
      fieldsWrapperStyles={{ pt: 10, flexDirection: 'column' }}
    />
    <FormFooter closeModal={props.closeModal} />
  </form>
);

export default enhance(ConnectToCustomMailForm);
